export const GET_PLATES = 'GET_PLATES';
export const PLATES_UPDATED = 'PLATES_UPDATED';